/**
 * Kis kék Modulum-ikon — a neve mellé kerül, ha a partner modulumos + aktív kapcsolat van.
 */
export default function ModulumBadge() {
  return (
    <span
      title="Modulum hálózati partner"
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: '16px', height: '16px', borderRadius: '4px',
        background: '#2563eb', color: '#fff',
        fontSize: '9px', fontWeight: 800, lineHeight: 1,
        letterSpacing: '-0.5px', flexShrink: 0,
      }}
    >
      M
    </span>
  );
}
